export const vAttributeReducer = data => {
  const newCategories = {}
  const categories = data.categories
  for (const catKey in categories) {
    const category = categories[catKey]
    if (Boolean(categories[catKey])) {
      category.values = category.values?.filter(itemValue =>
        filterCategoryValue(itemValue)
      )
      if (category.values && category.values.length > 0) {
        newCategories[catKey] = category
      }
    }
  }
  data.categories = newCategories
  return data
}

const filterCategoryValue = item => {
  const value = item.value

  if (Array.isArray(value)) {
    return item.value.some(itemValue => isValueAllowed(itemValue.value))
  } else {
    return isValueAllowed(value)
  }
}

const isValueAllowed = value => {
  return (
    Boolean(value) &&
    value !== 'OK' &&
    (typeof value === 'string' || typeof value === 'number')
  )
}
